module.exports = __webpack_public_path__ + "static/volunteer_top_img@2x-0b3312a02cae20196ec28b8e5a083f5c.png";